export default {
	'add-journal-cashbox': 'إضافة يومية الصندوق',
	'adding-journal-cashbox': 'أضف يومية الصندوق',
	'delete-journal': 'حذف اليومية',
	restriction: 'القيد',
	'total-received': 'مجموع المدين ',
	'paid-total': 'مجموع الدائن ',
	'new-journal': 'يومية جديدة',
	'the-difference': 'الفرق',
	'the-journal-has-been-migrated-successfully': 'تم اغلاق اليومية بنجاح.',
	'journal-saved-successfully': 'تم حفظ اليومية بنجاح',
	journal: 'البومية',
	'alert-message-for-date-matching': 'تاريخ اليومية غير مطابقة لتاريخ اليوم',
	description: 'شرح',
	'check-inputs-dialog': 'تنبيه بيانات غير محفوظة',
	'check-inputs-dialog-text': 'يوجد قيد لم تقم ب حفظه بعد هل تريد حفظه قبل إغلاق اليوم؟'
}